import DraggablePart from './DraggablePart'

export default DraggablePart
